<div class="sh-upload-panel -sh-is-raised" [ngClass]="!disabled && enableFileUpload ? '' : '-sh-no-border'">
    <img *ngIf="imageSrc" class="sh-upload-panel__figure" src="{{ imageSrc }}" alt="{{ imageAlt }}" role="presentation" aria-hidden="true" />
    <h2 *ngIf="title" class="sh-upload-panel__title">{{ title }}</h2>

    <ng-container *ngIf="!disabled">
        <p *ngIf="message" class="sh-upload-panel__message">{{ message }}</p>
        <button class="sh-upload-panel__controls sh-button sh-icon-button" for="file-upload" (keydown.enter)="onButtonClicked()">
            <svg *ngIf="buttonIcon" sh-icon [name]="buttonIcon" [size]="iconSize" aria-hidden="true" class="sh-icon-button__icon"></svg>
            {{ buttonText }}
            <input
                (click)="onButtonClicked()"
                (keydown.enter)="onButtonClicked()"
                (change)="fileInputChange($event)"
                class="sh-upload-panel__controls__hidden-control"
                id="file-upload"
                [type]="enableFileUpload ? 'file' : 'submit'"
                name="file-upload"
                [multiple]="multiple"
            />
        </button>
    </ng-container>
</div>
